<template>
  <g
    v-if="$root.$data.plugModeSaka === true"
    :transform="(flip === true ? `scale(-1 1) translate(-${ 2 * x} 0)`: '')"
  >
    <!-- Autoclose -->
    <rect :x="x - 3" :y="y - plugHeight / 2" :width="4" :height="plugHeight" fill="#d2d2d2"/>
    <!-- Plaste -->
    <rect :fill="color" :x="x" :height="plugHeight" :y="yRecalculated" :width="plugWidth + 1"/>
    <!-- Nase -->
    <rect
      :fill="getNoseColor(plugColor)"
      :x="x + plugWidth / 3"
      :height="6"
      :y="y - plugHeight / 2 + 6 / 2"
      :width="plugWidth / 4"
    />
    <rect
      :fill="getNoseColor(plugColor)"
      :x="x + plugWidth -5"
      :height="10"
      :y="y - plugHeight / 2 + 1"
      :width="plugWidth / 2"
    />
  </g>
  <g
    v-else
    :transform="(flip === true ? `scale(-.6 .6) translate(-${x/.6 + 16} ${y/.6 + 13}) rotate(-90)` : `scale(.6 .6) translate(${x/.6 - 16} ${y/.6 + 13}) rotate(-90)` )"
   stroke="white"
  >
    <rect x="0" y="0" width="16" height="100" fill="white"/>
    <rect :fill="color" stroke="white" x="3.5" y="9" width="18" height="61"/>
    <polygon
      fill="#ababab"
      stroke="white"
      points="20.001 5.5 20.001 0.5 5.5 0.5 5.5 5.5 3.5 5.5 3.5 9 21.5 9 21.5 5.5 20.001 5.5"
    />
    <rect :fill="color" stroke="white" x="0.5" y="73.4972" width="24" height="33.0028"/>
    <rect :fill="color" stroke="white" x="3.5" y="70" width="18" height="27"/>
    <rect fill="none" stroke="white" x="3.5" y="94" width="18" height="3"/>
    <rect fill="none" stroke="white" x="3.5" y="88" width="18" height="3"/>
    <rect fill="none" stroke="white" x="3.5" y="82" width="18" height="3"/>
    <polygon
      :fill="color" stroke="white"
      points="16.5 31.5 16.5 22.5 15 22.5 15 18.5 16.5 18.5 16.5 5.5 14 5.5 14 25.5 11 25.5 11 5.5 8.5 5.5 8.5 18.5 10 18.5 10 22.5 8.5 22.5 8.5 31.5 3.5 31.5 3.5 60 21.5 60 21.5 31.5 16.5 31.5"
    />
    <rect :fill="color" stroke="white" x="8.5" y="38.5" width="8" height="21.5"/>
    <rect fill="none" stroke="white" x="11" y="5.5" width="3" height="20"/>
  </g>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    plugColor: String,
    x: Number,
    y: Number,
    flip: Boolean
  },
  data() {
    return {
      plugWidth: 50,
      plugHeight: 12
    };
  },
  computed: {
    ...mapGetters([
      'getCssColor'
    ]),
    color () {
      return this.getCssColor(this.plugColor)
    },
    yRecalculated () {
      return this.y - this.plugHeight / 2
    }
  },
  methods: {
    getColor (colorName) { return this.getColor(colorName)},
    getNoseColor (colorName) { return this.getColor(colorName + "Nase")}
  }
}
</script>